export default __webpack_public_path__ + "static/media/chitmarrige1.0c5d0f64.jpeg";